module.exports = __webpack_public_path__ + "img/right.720b84ca.png";